import './loginForm.less';

import React from 'react';
import { observer } from 'mobx-react';
import b_ from 'b_';
import { EyeInvisibleOutlined, EyeOutlined, LockOutlined, UserOutlined } from '@ant-design/icons';

import { i18n } from 'core/localization';
import { useStore } from 'core/react/useStore';
import { AntAlert } from 'controls/react/ant/antAlert';
import { AntButton } from 'controls/react/ant/antButton';
import { AntInput } from 'controls/react/ant/antInput';
import { FormEntryNew } from 'controls/react/form/formEntryNew';
import { Section } from 'controls/react/layout/section';
import { LoginFormStore } from 'areas/login/components/login-form/loginFormStore';

const b = b_.with('login-form');

export const LoginForm = observer(() => {
	const store = useStore(() => new LoginFormStore());

	return (
		<form className={b()} onSubmit={store.onSubmit} noValidate>
			<Section appearance="none" childrenPadding>
				<h1 className={b('title')}>{i18n('Log in to Ceeview')}</h1>
				{store.failed && (
					<AntAlert
						type="error"
						showIcon
						message={
							store.errorMessage ||
							i18n('There might be a problem with your internet connection. Credentials not sent')
						}
					/>
				)}
				<FormEntryNew
					label={i18n('Username')}
					placeholder={i18n('Your username')}
					hasPlaceholder
					model={store.model}
					modelField="username"
					validator={store.validator}
					alwaysWithValue
					hideRequiredMark
				>
					<AntInput
						aria-label={i18n('Username')}
						variant="filled"
						autoComplete="username"
						autoFocus
						prefix={<UserOutlined />}
					/>
				</FormEntryNew>
				<FormEntryNew
					label={i18n('Password')}
					placeholder={store.validator.submitted ? i18n('Try your password again') : i18n('Your password')}
					hasPlaceholder
					model={store.model}
					modelField="password"
					validator={store.validator}
					alwaysWithValue
					hideRequiredMark
				>
					<AntInput
						aria-label={i18n('Password')}
						variant="filled"
						type={store.showPassword ? 'text' : 'password'}
						autoComplete="current-password"
						prefix={<LockOutlined />}
						suffix={
							<button
								type="button"
								className={b('toggle')}
								aria-label={store.toggleLabel}
								title={store.toggleLabel}
								onClick={store.toggleShowPassword}
							>
								{store.showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
							</button>
						}
					/>
				</FormEntryNew>
				<AntButton type="primary" htmlType="submit" loading={store.loading}>
					{i18n('Log in')}
				</AntButton>
			</Section>
		</form>
	);
});
